  (function () {
    // Mirrors the pricing table in the Cart Transform Function.
    // This is a UI preview only — the real, authoritative price is
    // calculated server-side by the Function at checkout.
    var PRICING_TABLE = {
      "50": { fixed: 51.70, rate: 2.11 },
      "100": { fixed: 55.45, rate: 3.80 },
      "200": { fixed: 60.28, rate: 7.02 },
      "300": { fixed: 66.53, rate: 9.76 },
      "500": { fixed: 78.95, rate: 14.84 },
      "1000": { fixed: 114.22, rate: 25.65 },
      "2000": { fixed: 175.85, rate: 44.05 },
      "3000": { fixed: 204.48, rate: 62.78 },
      "5000": { fixed: 286.72, rate: 96.00 },
      "10000": { fixed: 398.83, rate: 183.81 },
    };

    // The $0.01 carrier variant. A custom size is charged by adding
    // (price in cents) units of this variant, which Shopify multiplies back to
    // the exact price. It is a separate product so the Die Cut Stickers
    // variants are left completely alone.
    //
    // MUST be updated when moving between stores - a variant id from the dev
    // store will 404 on the add in production. Verify with:
    //   /products/die-cut-stickers-custom-size.js
    // Supplied by the block, because it is store-specific and this file is not.
    var DTF_CONFIG = window.DTF_CUSTOM_SIZE || {};

    // Resolved by Liquid from the carrier product's handle. Zero means the block
    // could not find it - not created yet, or not published to the Online Store.
    // Every custom size then goes to the quote form, which is exactly how the
    // store behaved before carrier pricing, so a half-finished install is safe.
    var CARRIER_VARIANT_ID = DTF_CONFIG.carrierVariantId || 0;
    var CARRIER_UNIT_CENTS = 1;              // the carrier variant's price, in cents

    // Minimum printable dimension, in inches. Specified by the client.
    var MIN_DIMENSION = 1.5;

    // No MAXIMUM is enforced - the client has not given one. A typo like 200x200
    // is therefore priced rather than rejected, and because that lands well over
    // MAX_LINE_CENTS it routes to the quote form, which is a reasonable place for
    // an implausible size to end up. Add an upper bound here and in
    // readDimensions if a real limit is ever given.

    // Shopify refuses more than 1,000,000 units on a single cart line. Measured
    // on dtf-test-2: 1,000,000 returns 200, 1,000,001 returns 422 "Cart Error".
    // Because the quantity IS the price in cents, that is a hard ceiling of
    // $10,000.00 per line. Anything dearer has to be quoted by hand.
    //
    // Worth knowing: when an add would push an EXISTING line past the cap,
    // Shopify does not reject it outright - it adds up to the cap and returns
    // 422 "Only 1000000 items were added to your cart due to availability", so
    // the cart is left holding LESS money than the order is worth. The unique
    // _line_id property below stops lines ever merging, which rules that out.
    var MAX_LINE_CENTS = 1000000;

    // Where to send anyone over the ceiling.
    var QUOTE_EMAIL = 'info@dtfnewengland.com';

    // Set by validateAndPreview, consumed by the add-to-cart interceptor. Zero
    // means "not priceable right now", which also keeps add-to-cart disabled.
    var currentPriceCents = 0;
    var currentWidth = null;
    var currentHeight = null;
    var currentTier = null;

    // variant id -> "Quantity" option value. Rendered by Liquid in the block and
    // handed over on window.DTF_CUSTOM_SIZE, because this file is a static asset
    // and cannot run Liquid. Reading the selected variant id is picker-agnostic:
    // it works with a dropdown, radios or Dawn's newer variant picker, and
    // survives section re-renders.
    var VARIANT_QUANTITY = DTF_CONFIG.variantQuantity || {};

    // Fix D: survives Dawn replacing the product-info section on variant change.
    var lastTypedSize = { w: '', h: '' };

    // Dawn-family themes render TWO forms posting to /cart/add: the real
    // product form, and a Shop Pay installments form that has no add button
    // and appears first in the DOM. A plain querySelector picks the wrong one,
    // and hidden inputs added to it are never submitted.
    function getProductForm() {
      var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));

      var candidates = forms.filter(function (form) {
        return (form.getAttribute('id') || '').indexOf('installment') === -1;
      });

      var withBuyButton = candidates.filter(function (form) {
        return form.querySelector('button[name="add"], [data-add-to-cart]');
      });

      return withBuyButton[0] || candidates[0] || forms[0] || null;
    }

    function getSelectedQuantity() {
      var form = getProductForm();

      // Preferred: map the selected variant id through the Liquid-rendered table.
      if (form) {
        var idField = form.querySelector('[name="id"]');
        if (idField && VARIANT_QUANTITY[idField.value]) {
          return String(VARIANT_QUANTITY[idField.value]);
        }
      }

      // Fallback: read the Quantity option control directly. Only selects and
      // radios are considered, which excludes the numeric cart stepper named
      // "quantity". Names are normalised to bare letters so "Quantity:",
      // "Quantity" and "options[Quantity:]" all match.
      var scope = form || document;
      var controls = scope.querySelectorAll('select[name], input[type="radio"][name]');

      for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        var normalised = (control.getAttribute('name') || '')
          .replace(/[^a-z0-9]/gi, '')
          .toLowerCase();

        if (normalised !== 'quantity' && normalised.slice(-8) !== 'quantity') continue;
        if (control.tagName === 'SELECT') return control.value;
        if (control.checked) return control.value;
      }

      return null;
    }

    // Must round identically to the Cart Transform Function, which works in
    // integer cents. A naive fixed + rate * w * h then toFixed(2) disagrees by
    // one cent on ~4.6% of sizes (e.g. qty 50 at 0.5x11 previews 63.30 but is
    // charged 63.31), so the preview would understate the real price.
    function priceFor(formula, width, height) {
      var cents = Math.round((formula.fixed + formula.rate * width * height) * 100);
      return cents / 100;
    }

    function formatUSD(amount) {
      return '$' + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    // Gates every buy control that submits this product: the add-to-cart button,
    // any dynamic checkout / "Buy it now" button, and buttons placed outside the
    // form that target it via the HTML form attribute (sticky bars do this).
    // Deliberately scoped to this product's form so unrelated product cards or
    // recommendation carousels on the same page are left alone.
    function setAddToCartEnabled(enabled) {
      var form = getProductForm();
      var selectors = [
        'button[name="add"]',
        'button[type="submit"][name="add"]',
        '[data-add-to-cart]',
        '[data-testid="standalone-add-to-cart"]',
        '.shopify-payment-button__button',
        '.product-form__submit'
      ];

      var buttons = [];
      if (form) {
        buttons = buttons.concat([].slice.call(form.querySelectorAll(selectors.join(','))));
        if (form.id) {
          buttons = buttons.concat(
            [].slice.call(document.querySelectorAll('[form="' + form.id + '"]'))
          );
        }
      }

      buttons.forEach(function (button) {
        if (typeof button.disabled === 'boolean') button.disabled = !enabled;
        // The Custom Size variants are deliberately held out of stock so that a
        // JS failure cannot produce an order at their placeholder price. Dawn
        // marks the button aria-disabled for those variants, which keeps it
        // unclickable even after .disabled is cleared, so clear that too.
        if (enabled) button.removeAttribute('aria-disabled');
      });
    }

    // Because the Custom Size variants are out of stock, the theme renders the
    // button as a disabled "Sold out". In carrier mode the line IS buyable (via
    // the carrier variant), so the label has to be corrected as well as the
    // disabled state. Pass null to put the theme's own label back.
    function setAddToCartLabel(text) {
      var form = getProductForm();
      var button = form && form.querySelector('button[name="add"]');
      if (!button) return;

      var target = button.querySelector('span:not(.visually-hidden)') || button;

      if (text === null) {
        // Hand the button back to the theme. Deliberately does NOT restore a
        // remembered label: the theme rewrites the label itself on every
        // variant change, and the one we would have remembered is the
        // "Sold out" the Custom Size variant was showing.
        delete button.dataset.dtfLabelOverridden;
        return;
      }
      button.dataset.dtfLabelOverridden = 'true';
      if (target.textContent !== text) target.textContent = text;
    }

    // "Buy it now" bypasses the cart and checks out the form's own variant,
    // which for a custom size is the unbuyable placeholder. There is no way to
    // route it through the carrier line, so it is removed in custom mode.
    function setDynamicCheckoutVisible(visible) {
      var form = getProductForm();
      if (!form) return;
      var area = form.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
      if (area) area.style.display = visible ? '' : 'none';
    }

    // Reads the two dimension inputs. Returns null with a reason when the pair
    // is not yet usable, so the caller can say which field is wrong.
    function readDimensions() {
      var wEl = document.getElementById('custom_size_w');
      var hEl = document.getElementById('custom_size_h');
      if (!wEl || !hEl) return { error: null };

      var wRaw = wEl.value.trim();
      var hRaw = hEl.value.trim();
      if (!wRaw && !hRaw) return { error: null };            // untouched, not an error
      if (!wRaw) return { error: 'Enter a width.' };
      if (!hRaw) return { error: 'Enter a height.' };

      var w = parseFloat(wRaw);
      var h = parseFloat(hRaw);
      // Negative and zero first, so the message names the actual problem rather
      // than quoting a minimum at someone who typed "-3".
      if (!(w > 0) || !(h > 0)) return { error: 'Width and height must be greater than 0.' };

      if (w < MIN_DIMENSION || h < MIN_DIMENSION) {
        return { error: 'Minimum size is ' + MIN_DIMENSION + '" on each side.' };
      }

      return { width: w, height: h, error: null };
    }

    // Trailing zeros read as false precision on an order ("10.00 x 2.00"), so
    // 10 stays 10 while 3.5 keeps its decimal.
    function formatDimension(value) {
      return String(Math.round(value * 100) / 100);
    }

    function validateAndPreview() {
      var errorEl = document.getElementById('custom-size-error');
      var priceEl = document.getElementById('custom-size-price');
      var widthField = document.getElementById('custom_size_width');
      var heightField = document.getElementById('custom_size_height');
      var displayField = document.getElementById('custom_size_display');

      if (!widthField || !heightField) return;

      function showPrice(html) {
        if (priceEl) {
          priceEl.innerHTML = html;
          priceEl.style.display = html ? 'block' : 'none';
        }
      }

      function reject(message) {
        currentPriceCents = 0;
        currentWidth = null;
        currentHeight = null;
        currentTier = null;
        setHiddenFieldsSubmitted(false);
        widthField.value = '';
        heightField.value = '';
        displayField.value = '';
        if (message) {
          errorEl.textContent = message;
          errorEl.style.display = 'block';
        } else {
          errorEl.style.display = 'none';
        }
        setAddToCartEnabled(false);
      }

      var dims = readDimensions();
      var quantity = getSelectedQuantity();

      if (dims.error || !dims.width) {
        setCeilingQuoteMode(false);
        fillQuote(null, null, quantity, '');
        showPrice(dims.error
          ? ''
          : '<span style="font-size:15px; opacity:.75;">Enter a width and height to see your price</span>');
        return reject(dims.error);
      }

      var width = dims.width;
      var height = dims.height;

      errorEl.style.display = 'none';
      setHiddenFieldsSubmitted(true);
      widthField.value = width;
      heightField.value = height;
      displayField.value = formatDimension(width) + 'x' + formatDimension(height);

      var formula = quantity ? PRICING_TABLE[quantity] : null;

      if (!formula) {
        // No tier resolved - almost always a Quantity option that has not been
        // touched yet. Priceable as soon as it is.
        currentPriceCents = 0;
        currentTier = null;
        showPrice('<span style="font-size:15px; opacity:.75;">Select a quantity to see your price</span>');
        setCeilingQuoteMode(false);
        fillQuote(null, null, quantity, '');
        setAddToCartEnabled(false);
        return;
      }

      // Integer cents throughout: this is the figure that gets charged, as a
      // quantity of carrier units, so it must not drift by rounding.
      var cents = Math.round((formula.fixed + formula.rate * width * height) * 100);
      currentPriceCents = cents;
      currentWidth = width;
      currentHeight = height;
      currentTier = quantity;

      var price = cents / 100;

      if (cents > MAX_LINE_CENTS || !CARRIER_VARIANT_ID) {
        // Show the figure anyway - it tells them roughly where they have landed -
        // but the line cannot be created, so do not let them try.
        showPrice(
          '<span style="font-size:22px; font-weight:600; display:block;">' + formatUSD(price) + '</span>'
          + '<span style="font-size:14px; opacity:.75; display:block; margin-top:2px;">'
          + formatDimension(width) + '&quot; &times; ' + formatDimension(height) + '&quot;, '
          + quantity + ' stickers</span>'
        );
        // Not an error the customer can fix by retyping, so no red message -
        // the quote form below explains it and collects what we need.
        setCustomSizeError(null);
        // With no carrier product there is nothing special about the amount, so
        // do not tell the customer their order is unusually large.
        setQuoteIntro(CARRIER_VARIANT_ID ? price : null);
        fillQuote(width, height, quantity, formatUSD(price));
        setCeilingQuoteMode(true);
        setAddToCartEnabled(false);
        return;
      }

      showPrice(
        '<span style="font-size:22px; font-weight:600; display:block;">' + formatUSD(price) + '</span>'
        + '<span style="font-size:14px; opacity:.75; display:block; margin-top:2px;">'
        + formatDimension(width) + '&quot; &times; ' + formatDimension(height) + '&quot;, '
        + quantity + ' stickers</span>'
      );

      setCeilingQuoteMode(false);
      fillQuote(null, null, quantity, '');
      setAddToCartEnabled(true);
      if (CARRIER_MODE) setAddToCartLabel('Add to cart');
    }

    // The price belongs where the theme's price block sits, not tucked under the
    // inputs - it is the product price for this configuration. Re-runnable: the
    // theme rebuilds this markup on every variant change.
    function placePriceDisplay() {
      var priceEl = document.getElementById('custom-size-price');
      if (!priceEl) return;

      var scope = document.querySelector('.product__info-container, .product__info-wrapper');
      if (!scope) return;

      var themePrice = scope.querySelector('[id^="price-"]') || scope.querySelector('.price');
      var anchor = themePrice && themePrice.parentElement ? themePrice : null;

      if (anchor) {
        if (anchor.nextElementSibling !== priceEl) {
          anchor.insertAdjacentElement('afterend', priceEl);
        }
        return;
      }
      // No price block to anchor to: fall back to directly under the inputs.
      var field = document.getElementById('custom-size-field');
      if (field && field.nextElementSibling !== priceEl) {
        field.insertAdjacentElement('afterend', priceEl);
      }
    }

    // The Order notes placeholder, applied to EVERY size on this product - custom
    // and fixed alike. The theme's own text ("...special notes for delivery") is
    // Dawn boilerplate and wrong for a print product at any size.
    //
    // Set at runtime rather than in the block, because the field lives in its own
    // custom-liquid block that the theme re-renders on every variant change; an
    // edit made there would be correct but this has to be re-applied afterwards
    // regardless, so there is one place to change it rather than two.
    //
    // Scope: this product only. The asset is loaded by the Die Cut Stickers
    // template's block, so no other product's notes field is touched.
    var ORDER_NOTES_PLACEHOLDER = 'Notes about your order, e.g. die cut placement';

    function setOrderNotesPlaceholder() {
      var notes = document.getElementById('order_notes');
      if (!notes) return;
      if (notes.getAttribute('placeholder') !== ORDER_NOTES_PLACEHOLDER) {
        notes.setAttribute('placeholder', ORDER_NOTES_PLACEHOLDER);
      }
    }

    // Applies to every size on this product, so it is never hidden - only moved.
    // Sits directly under the price, the most prominent place on the page.
    function placeShippingNotice() {
      var notice = document.getElementById('custom-size-shipping-notice');
      var price = document.getElementById('custom-size-price');
      if (!notice || !price) return;
      if (price.nextElementSibling !== notice) {
        price.insertAdjacentElement('afterend', notice);
      }
    }

    function getPeelValue() {
      var peel = null;
      document.querySelectorAll('fieldset.js.product-form__input').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend) return;
        if (legend.textContent.trim().toLowerCase().indexOf('peel') === 0) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) peel = checked.value;
        }
      });
      return peel;
    }

    // Everything the workshop needs to make the sticker, plus a hidden record of
    // how the price was arrived at. The carrier line carries no variant options
    // of its own, so these properties are the ONLY description of the order -
    // anything omitted here is lost.
    //
    // Keys starting with "_" are hidden from the customer in the cart and on the
    // order page, but are still present in the order data and exports.
    function collectCustomProperties() {
      var finish = document.querySelector('input[name="properties[Finish]"]:checked');
      var external = document.getElementById('external_link');
      var notes = document.getElementById('order_notes');
      var peel = getPeelValue();

      var props = {
        'Size': formatDimension(currentWidth) + '" x ' + formatDimension(currentHeight) + '"',
        'Width (in)': formatDimension(currentWidth),
        'Height (in)': formatDimension(currentHeight),
        // Named explicitly: the cart line's own quantity field carries the price
        // in cents, so a bare "Quantity" here would be read as that.
        'Quantity (stickers)': currentTier,
        'Peel Here Tab': peel || '',
        'Finish': finish ? finish.value : '',
        'External Link': external ? external.value.trim() : '',
        'Order Notes': notes ? notes.value.trim() : '',
        // For reconciliation if a price is ever disputed.
        '_price_cents': String(currentPriceCents),
        '_pricing': 'carrier v1',
        // Makes every add its own cart line. Without it, adding the same
        // configuration twice merges the lines and DOUBLES the quantity - which,
        // since the quantity is the price, doubles the charge while the line
        // still reads "50 stickers". It also keeps a merge from silently
        // clamping at the 1,000,000 cap and undercharging.
        '_line_id': String(Date.now()) + '-' + String(Math.floor(Math.random() * 1e6))
      };

      // An empty property prints as a blank row on the packing slip.
      Object.keys(props).forEach(function (key) {
        if (props[key] === '' || props[key] === null || props[key] === undefined) {
          delete props[key];
        }
      });
      return props;
    }

    // Above MAX_LINE_CENTS the carrier line cannot be created, so the order has
    // to be quoted by hand. Swap the buy controls for the quote request - the
    // same form that ran for every custom size before carrier pricing.
    //
    // Upload and the large-file link go with the buy area: a quote is a contact
    // form submission and cannot carry a file, so leaving an upload on screen
    // would be a trap. The link field's value is still copied into the request.
    function setCeilingQuoteMode(active) {
      setQuoteVisible(active);
      setBuyAreaVisible(!active);
      setUploadVisible(!active);
      setLargeFileFieldVisible(!active);
    }

    function setQuoteIntro(price) {
      var intro = document.getElementById('custom-size-quote-intro');
      if (!intro) return;
      // Deliberately says nothing about what the site cannot do - an order this
      // size is a good problem, and the customer should read it as bespoke
      // service rather than a rejection.
      intro.textContent = price === null
        ? "This size is quoted individually. Send us the details and we'll email you a price."
        : 'This works out to about ' + formatUSD(price) + '. Orders this size are quoted '
          + "individually, so send us the details and we'll email you a firm price.";
    }

    function setCustomSizeError(message) {
      var errorEl = document.getElementById('custom-size-error');
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.style.display = message ? 'block' : 'none';
    }

    // Adds the carrier line instead of the product's own variant. The Custom
    // Size variants are held out of stock precisely so that if this never runs,
    // the theme's submit cannot produce an order at their placeholder price.
    function submitCarrierLine() {
      if (!CARRIER_VARIANT_ID) {
        // Should be unreachable: without a carrier the quote form is shown and
        // add-to-cart is disabled. Belt and braces, because the alternative is
        // posting quantity-as-price to variant 0.
        setCustomSizeError('Please use the quote form below for this size.');
        return;
      }
      if (!currentPriceCents || !currentWidth || !currentHeight || !currentTier) {
        setCustomSizeError('Enter a width, a height and a quantity first.');
        return;
      }

      var form = getProductForm();
      var button = form && form.querySelector('button[name="add"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');
        button.disabled = true;
      }

      var payload = {
        items: [{
          id: CARRIER_VARIANT_ID,
          quantity: currentPriceCents / CARRIER_UNIT_CENTS,
          properties: collectCustomProperties()
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, status: response.status, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error(
              (result.body && (result.body.description || result.body.message))
              || ('Add to cart failed (' + result.status + ')')
            );
          }
          // Deliberately a full navigation rather than a cart-drawer refresh:
          // the drawer's update API differs between theme versions, and the
          // line needs checking anyway because its quantity is the price.
          window.location.href = '/cart';
        })
        .catch(function (error) {
          var message = error && error.message ? error.message : '';
          // Backstop: validation should have caught this before the request.
          if (/Cart Error|availability/i.test(message)) {
            message = 'An order this size is quoted individually — email ' + QUOTE_EMAIL
              + ' and we will send you a firm price.';
            setCustomSizeError(message);
          } else {
            setCustomSizeError('Sorry, we could not add that to your cart. ' + message);
          }
          if (button) {
            button.removeAttribute('aria-busy');
            button.classList.remove('loading');
            button.disabled = false;
          }
        });
    }

    // Bound on document in the CAPTURE phase so it runs before the theme's own
    // submit handler on the form, which would otherwise post the unbuyable
    // Custom Size variant. Fixed sizes are not touched: the theme handles them.
    function bindCarrierSubmit() {
      if (document.documentElement.dataset.dtfCarrierBound) return;
      document.documentElement.dataset.dtfCarrierBound = 'true';

      document.addEventListener('submit', function (event) {
        if (!CARRIER_MODE) return;
        var form = getProductForm();
        if (!form || event.target !== form) return;
        if (!customSizeActive()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        submitCarrierLine();
      }, true);

      // Dawn's button is type="submit" inside the form, so the submit event
      // above covers it. A theme that wires the button to a click handler
      // instead never fires submit, so cover that too - guarded on the same
      // conditions, and harmless when the submit path already ran.
      document.addEventListener('click', function (event) {
        if (!CARRIER_MODE) return;
        var button = event.target && event.target.closest
          ? event.target.closest('button[name="add"], [data-add-to-cart]')
          : null;
        if (!button) return;

        var form = getProductForm();
        if (!form || !form.contains(button)) return;
        if (!customSizeActive()) return;
        if (button.type === 'submit' && button.form) return; // the submit handler owns it

        event.preventDefault();
        event.stopImmediatePropagation();
        submitCarrierLine();
      }, true);
    }

    // Fix A: the hidden properties only submit if they live inside the product
    // form. Prefer sitting just after the Size fieldset (original behaviour);
    // otherwise fall back to the form itself so they always submit.
    function findSizeFieldset() {
      var found = null;
      document.querySelectorAll('fieldset.js.product-form__input').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (legend && legend.textContent.trim().toLowerCase().indexOf('size') === 0) {
          found = fs;
        }
      });
      return found;
    }

    // The estimate and request button must come after every option group, so
    // the customer has already chosen Quantity and Peel before submitting.
    // Anchored to the last option fieldset, which sits outside the add-to-cart
    // form in this theme, so no nested form is created.
    function placeQuote() {
      var quote = document.getElementById('custom-size-quote');
      if (!quote) return;

      // Directly above the buy area, which is the last thing in the column. That
      // puts the request after every other input the customer fills in - the
      // Finish radios, the artwork upload, the large-file link and the order
      // notes - so nothing is left unset when they submit. <product-form> is the
      // buy area's own element and sits outside any form, so inserting before it
      // does not nest forms.
      var buyWrapper = document.querySelector('product-form')
        || document.querySelector('.product-form');
      if (buyWrapper && buyWrapper.previousElementSibling !== quote) {
        buyWrapper.insertAdjacentElement('beforebegin', quote);
        return;
      }
      if (buyWrapper) return;

      // No buy area found: fall back to after the last option group.
      var fieldsets = document.querySelectorAll('fieldset.js.product-form__input');
      if (fieldsets.length) {
        var last = fieldsets[fieldsets.length - 1];
        if (last.nextElementSibling !== quote) {
          last.insertAdjacentElement('afterend', quote);
        }
      }
    }

    // Three of the theme's own line item property controls - Finish, the
    // large-file link and Order notes - are rendered in blocks that sit OUTSIDE
    // the add-to-cart form, so nothing a customer enters in them has ever
    // reached an order. Confirmed against real orders. Rather than move the
    // controls (they are visible UI and belong where they are), their values are
    // mirrored into hidden inputs placed inside the form.
    var MIRRORED_PROPERTIES = [
      {
        name: 'properties[Finish]',
        probe: 'input[name="properties[Finish]"]',
        read: function () {
          var checked = document.querySelector('input[name="properties[Finish]"]:checked');
          return checked ? checked.value : '';
        }
      },
      {
        name: 'properties[External Link]',
        probe: '#external_link',
        read: function () {
          var el = document.getElementById('external_link');
          return el ? el.value.trim() : '';
        }
      },
      {
        name: 'properties[Order Notes]',
        probe: '#order_notes',
        read: function () {
          var el = document.getElementById('order_notes');
          return el ? el.value.trim() : '';
        }
      },
      {
        name: 'properties[Cut]',
        probe: 'input[name="properties[Cut]"]',
        read: function () {
          var checked = document.querySelector('input[name="properties[Cut]"]:checked');
          return checked ? checked.value : '';
        }
      },
      {
        name: 'properties[Cutting Notes]',
        probe: '#cutting_notes',
        read: function () {
          var el = document.getElementById('cutting_notes');
          return el ? el.value.trim() : '';
        }
      }
    ];

    function syncMirroredProperties() {
      var props = document.getElementById('custom-size-properties');
      var form = getProductForm();
      if (!props || !form) return;

      MIRRORED_PROPERTIES.forEach(function (spec, index) {
        var original = document.querySelector(spec.probe);
        if (!original) return;

        // If the theme is ever fixed so these sit inside the form, mirroring
        // would submit the property twice. Let the original win.
        if (form.contains(original)) return;

        var id = 'dtf-mirrored-property-' + index;
        var input = document.getElementById(id);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.id = id;
          input.name = spec.name;
          props.appendChild(input);
        } else if (!props.contains(input)) {
          props.appendChild(input);
        }

        var value = spec.read();
        input.value = value;
        // An empty property would print as a blank row on the order and packing
        // slip, so it is left out entirely.
        input.disabled = !value;
      });
    }

    // The hidden properties are the only part that MUST live inside the form.
    // Keeping this separate from the visible field means the input can sit
    // directly under the Size option — where it sits in production — even
    // though that markup is outside the form in this theme.
    function placeProperties() {
      var props = document.getElementById('custom-size-properties');
      var form = getProductForm();
      if (!props || !form || form.contains(props)) return;
      form.appendChild(props);
    }

    // Visible field: match production's position (immediately after the Size
    // option). Falls back to the form only if there is no Size option to
    // anchor to, which is the free-text end state.
    function placeCustomSizeField() {
      var field = document.getElementById('custom-size-field');
      if (!field) return;

      var sizeFieldset = findSizeFieldset();
      if (sizeFieldset) {
        if (field.previousElementSibling !== sizeFieldset) {
          sizeFieldset.insertAdjacentElement('afterend', field);
        }
        return;
      }

      var form = getProductForm();
      if (!form || form.contains(field)) return;

      var anchor = form.querySelector('.product-form__buttons')
        || form.querySelector('button[name="add"], [data-add-to-cart], [data-testid="standalone-add-to-cart"]');

      if (anchor) {
        var container = anchor.parentElement === form ? anchor : (anchor.closest('div') || anchor);
        container.insertAdjacentElement('beforebegin', field);
      } else {
        form.appendChild(field);
      }
    }

    // The theme shows this badge purely via CSS (.price--sold-out class on the
    // container), independent of setThemePriceVisible - so restoring the price
    // block's visibility for a fixed size does not clear it. Fixed sizes are
    // sold out for good now, so the badge is just hidden outright rather than
    // relying on the theme's own sold-out state, which reads as broken here.
    function hideSoldOutBadge() {
      var scope = document.querySelector('.product__info-container, .product__info-wrapper');
      var badge = scope && scope.querySelector('.price__badge-sold-out');
      if (badge) badge.style.display = 'none';
    }

    // A fixed price label is meaningless for a custom size — the real figure is
    // computed at checkout — so the theme's price is hidden and the estimate
    // below the size input stands in for it. Restored the moment a fixed size
    // is chosen again. Scoped to this product's info area so the cart drawer
    // and any other prices on the page are untouched.
    function setThemePriceVisible(visible) {
      var scope = document.querySelector('.product__info-container, .product__info-wrapper');
      if (!scope) return;

      var targets = [];

      // The whole price block, not just .price__container. The "Sold out" badge
      // is a sibling of the container inside the same block, so hiding only the
      // container leaves the badge on screen - and a custom size is not sold
      // out, it is quoted. Nothing here is for sale in this state, so the Sale
      // and Sold out badges have nothing to advertise either.
      var priceBlock = scope.querySelector('[id^="price-"]') || scope.querySelector('.price');
      if (priceBlock) targets.push(priceBlock);

      var perItem = scope.querySelector('.price-per-item__container');
      if (perItem) targets.push(perItem);

      targets.forEach(function (el) {
        el.style.display = visible ? '' : 'none';
      });
    }

    // Whether a custom size is what governs the price right now. Pure - no side
    // effects - so the add-to-cart interceptor and syncVisibility can both ask
    // without one of them reshuffling the DOM as a side effect.
    function customSizeActive() {
      if (!CUSTOM_SIZE_UI) return false;
      // Free-text model: no "Custom Size" option exists, so it always applies.
      if (!hasCustomSizeOption()) return true;
      return !!(
        document.querySelector('input[type="radio"][value="Custom Size"]:checked')
        || document.querySelector('select option[value="Custom Size"]:checked')
      );
    }

    // Fix B: with Size converted to free text there is no "Custom Size" option
    // to toggle on, so the field must show unconditionally.
    function hasCustomSizeOption() {
      return !!document.querySelector(
        'input[type="radio"][value="Custom Size"], select option[value="Custom Size"]'
      );
    }

    // A disabled input is not submitted at all. Without this, a fixed-size order
    // carries empty "Width", "Height" and "Custom Size" properties onto the
    // cart line, the order and the packing slip.
    function setHiddenFieldsSubmitted(submitted) {
      ['custom_size_width', 'custom_size_height', 'custom_size_display'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.disabled = !submitted;
      });
    }

    function clearSizeFields() {
      var wInput = document.getElementById('custom_size_w');
      var hInput = document.getElementById('custom_size_h');
      var widthField = document.getElementById('custom_size_width');
      var heightField = document.getElementById('custom_size_height');
      var displayField = document.getElementById('custom_size_display');
      var errorEl = document.getElementById('custom-size-error');
      var priceEl = document.getElementById('custom-size-price');

      lastTypedSize = { w: '', h: '' };
      currentPriceCents = 0;
      currentWidth = null;
      currentHeight = null;
      currentTier = null;
      setHiddenFieldsSubmitted(false);
      // A hidden quote form must never keep values from a size the customer has
      // since moved away from.
      fillQuote(null, null, null, '');
      if (wInput) wInput.value = '';
      if (hInput) hInput.value = '';
      if (widthField) widthField.value = '';
      if (heightField) heightField.value = '';
      if (displayField) displayField.value = '';
      if (errorEl) errorEl.style.display = 'none';
      if (priceEl) {
        priceEl.innerHTML = '';
        priceEl.style.display = 'none';
      }
    }

    // Custom sizes are bought via the $0.01 carrier variant (see
    // CARRIER_VARIANT_ID). Set false and QUOTE_MODE true to go back to
    // collecting quote requests instead of orders.
    var CARRIER_MODE = true;

    // Set false when a pricing app owns the custom-size input, the price and the
    // add-to-cart. Our own size field, estimate and quote form then stay out of
    // the way, and nothing hides the theme price, the buy area, the artwork
    // upload or the large-file link - otherwise the two fight each other.
    //
    // What still applies with this off, because none of it is custom-size
    // specific: mirroring Finish / External Link / Order Notes into the cart
    // form, hiding the cart-quantity block, and un-striking option labels.
    var CUSTOM_SIZE_UI = true;

    var QUOTE_SEEN_KEY = 'dtfCustomSizeQuoteSeen';
    var QUOTE_PENDING_KEY = 'dtfCustomSizeQuotePending';

    // Read the pending flag once, at load, and consume it immediately. The submit
    // handler on THIS page also writes that flag, and Shopify's captcha runs a
    // challenge before the form actually posts - so re-reading it later would
    // show the confirmation while the captcha is still open, behind it.
    var quotePostedOnPreviousLoad = false;
    try {
      quotePostedOnPreviousLoad = sessionStorage.getItem(QUOTE_PENDING_KEY) === '1';
      if (quotePostedOnPreviousLoad) sessionStorage.removeItem(QUOTE_PENDING_KEY);
    } catch (e) {}

    // Whether the confirmation should be displayed during this page view.
    // Decided once in init(), never re-derived.
    var showConfirmation = false;
    var confirmationScrolled = false;

    // Neutralise the theme's sold-out styling on options that are only
    // unavailable because custom sizes are quoted rather than sold. The
    // "Custom Size" value is always treated this way; the Quantity and Peel
    // options only while a custom size is selected, so a genuine stock-out on
    // a fixed size still shows correctly.
    function setQuotableStyling(customModeActive) {
      document.querySelectorAll('fieldset.js.product-form__input').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        var name = legend ? legend.textContent.trim().toLowerCase() : '';
        var isSize = name.indexOf('size') === 0;

        fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (!label) return;

          var quotable = isSize
            ? input.value === 'Custom Size'
            : customModeActive;

          var note = label.querySelector('.visually-hidden');
          if (quotable) {
            label.classList.add('dtf-quotable');
            // Screen readers would otherwise announce "sold out" for an option
            // we are presenting as selectable.
            if (note) {
              if (!note.dataset.dtfOriginal) note.dataset.dtfOriginal = note.textContent;
              note.textContent = input.value === 'Custom Size' ? 'Price on request' : '';
            }
          } else {
            label.classList.remove('dtf-quotable');
            if (note && note.dataset.dtfOriginal) note.textContent = note.dataset.dtfOriginal;
          }
        });
      });
    }

    // Decided once per page view, in init(). Shopify keeps
    // form.posted_successfully? true for the whole session, so the panel would
    // otherwise reappear on every reload with no way to clear it.
    function decideConfirmation() {
      var success = document.getElementById('custom-size-quote-success');
      var posted = (success && success.getAttribute('data-posted') === 'true')
        || quotePostedOnPreviousLoad;

      var seen = false;
      try { seen = sessionStorage.getItem(QUOTE_SEEN_KEY) === '1'; } catch (e) {}

      showConfirmation = posted && !seen;

      // Mark it seen straight away, so a reload does not resurrect it.
      if (showConfirmation) {
        try { sessionStorage.setItem(QUOTE_SEEN_KEY, '1'); } catch (e) {}
      }
    }

    // Relocates the confirmation out of the collapsible field into a container
    // that is always visible, so it shows whichever variant the reloaded page
    // defaults to. Re-runnable: the theme rebuilds this markup on every variant
    // change.
    function handleQuoteConfirmation() {
      var success = document.getElementById('custom-size-quote-success');
      var notice = document.getElementById('custom-size-quote-notice');
      if (!success || !notice) return;

      if (!showConfirmation) {
        // Liquid re-renders it visible while posted_successfully? holds, so keep
        // hiding it after a section re-render.
        success.style.display = 'none';
        notice.style.display = 'none';
        return;
      }

      if (!notice.contains(success)) notice.appendChild(success);
      notice.style.display = 'block';
      success.style.display = 'block';

      var fields = document.getElementById('custom-size-quote-fields');
      if (fields) fields.style.display = 'none';

      // Shopify's contact form action carries an anchor, so the browser jumps to
      // the form - hidden at this point - leaving the confirmation off screen.
      if (!confirmationScrolled) {
        confirmationScrolled = true;
        try {
          success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e) {
          success.scrollIntoView();
        }
      }

      var dismiss = document.getElementById('custom-size-quote-dismiss');
      if (dismiss && !dismiss.dataset.dtfBound) {
        dismiss.dataset.dtfBound = 'true';
        dismiss.addEventListener('click', function () {
          showConfirmation = false;
          notice.style.display = 'none';
          success.style.display = 'none';
          if (fields) fields.style.display = '';
        });
      }
    }

    function getBuyArea() {
      var form = getProductForm();
      if (!form) return null;
      return form.querySelector('.product-form__buttons')
        || form.closest('product-form, .product-form')
        || form;
    }

    function setBuyAreaVisible(visible) {
      var area = getBuyArea();
      if (area) area.style.display = visible ? '' : 'none';
    }

    // A quote request is a contact-form submission and cannot carry a file, so an
    // upload control in this state is a trap: the customer attaches artwork that
    // goes nowhere. The large-file link field stays visible and IS included in
    // the request, which is the working route for custom sizes.
    function setUploadVisible(visible) {
      var blocks = document.querySelectorAll('[id^="shopify-block-"]');
      blocks.forEach(function (block) {
        var isUpload = block.id.toLowerCase().indexOf('uploadery') !== -1
          || block.querySelector('input[type="file"], [class*="uploadery"], [id*="uploadery"]');
        if (isUpload) block.style.display = visible ? '' : 'none';
      });
    }

    // With no upload and no add-to-cart, the large-file link has nothing to
    // attach to: the store follows up by email with the quote, and artwork is
    // arranged then. Hidden for custom sizes, restored for fixed sizes.
    function setLargeFileFieldVisible(visible) {
      var field = document.getElementById('large-file-field');
      if (!field) return;
      field.style.display = visible ? '' : 'none';

      // Custom liquid blocks are not wrapped in a container, so the file-format
      // guidance is a bare <p> sibling from the same block. It describes nothing
      // but uploading, so it follows the field. Delete this stanza to keep the
      // guidance on screen for custom sizes.
      var previous = field.previousElementSibling;
      if (previous && previous.tagName === 'P' && /file|format|dpi|mb/i.test(previous.textContent || '')) {
        previous.style.display = visible ? '' : 'none';
      }
    }

    function setQuoteVisible(visible) {
      var quote = document.getElementById('custom-size-quote');
      if (quote) quote.style.display = visible ? 'block' : 'none';
    }

    // Mirrors the validated size into the quote request, so the email carries
    // everything needed to price it without a follow-up exchange.
    function fillQuote(width, height, quantity, estimate) {
      var set = function (id, value) {
        var el = document.getElementById(id);
        if (el) el.value = value;
      };
      var peel = null;
      document.querySelectorAll('fieldset.js.product-form__input').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend) return;
        if (legend.textContent.trim().toLowerCase().indexOf('peel') === 0) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) peel = checked.value;
        }
      });

      // The theme renders Finish, the large-file link and Order notes in their
      // own blocks. Copy whatever the customer entered so the quote email is
      // self-contained.
      var finishInput = document.querySelector('input[name="properties[Finish]"]:checked');
      var externalInput = document.getElementById('external_link');
      var notesInput = document.getElementById('order_notes');
      set('quote_finish', finishInput ? finishInput.value : '');
      set('quote_external', externalInput ? externalInput.value : '');
      set('quote_body', notesInput ? notesInput.value : '');

      var valid = width !== null && height !== null && quantity;
      set('quote_width', valid ? width : '');
      set('quote_height', valid ? height : '');
      set('quote_size', valid ? width + 'x' + height : '');
      set('quote_quantity', quantity || '');
      set('quote_peel', peel || '');
      set('quote_estimate', estimate || '');

      var submit = document.getElementById('quote_submit');
      var hint = document.getElementById('quote_hint');
      if (submit) submit.disabled = !valid;
      if (hint) hint.style.display = valid ? 'none' : '';
    }

    // Returns true when a custom size is what governs the price.
    function syncVisibility() {
      var field = document.getElementById('custom-size-field');
      if (!field) return false;

      // Independent of which size is selected, and re-applied here because the
      // theme rebuilds the notes block on every variant change.
      setOrderNotesPlaceholder();

      if (!CUSTOM_SIZE_UI) {
        // Leave every surface exactly as the theme and the pricing app expect.
        field.style.display = 'none';
        setQuoteVisible(false);
        setThemePriceVisible(true);
        setBuyAreaVisible(true);
        setUploadVisible(true);
        setLargeFileFieldVisible(true);
        setDynamicCheckoutVisible(true);
        setAddToCartLabel(null);
        setQuotableStyling(false);
        return false;
      }

      if (customSizeActive()) {
        field.style.display = 'block';
        // Our own figure stands in for the theme's, which shows the Custom Size
        // variant's placeholder price.
        setThemePriceVisible(false);
        setQuotableStyling(true);

        // The customer really is buying, so every buy control stays available
        // except "Buy it now", which cannot be routed through the carrier line.
        setBuyAreaVisible(true);
        setUploadVisible(true);
        setLargeFileFieldVisible(true);
        setDynamicCheckoutVisible(false);
        return true;
      }

      // A fixed size variant is selected. Hiding the field is not enough: stale
      // Width/Height would still submit and land on the order, so clear them
      // and let the variant's own price and the theme's own submit stand.
      field.style.display = 'none';
      clearSizeFields();
      setThemePriceVisible(true);
      hideSoldOutBadge();
      setQuoteVisible(false);
      setBuyAreaVisible(true);
      setUploadVisible(true);
      setLargeFileFieldVisible(true);
      setDynamicCheckoutVisible(true);
      setQuotableStyling(false);
      // Fixed sizes are sold out for good now - all sticker orders go through
      // Custom Size. "Sold out" reads as a broken page rather than a
      // deliberate choice, so the button stays a plain, disabled "Add to
      // cart" instead. It only becomes real (and enabled) once a valid
      // Custom Size is entered, via setAddToCartLabel/setAddToCartEnabled in
      // validateAndPreview. Harmless if a fixed size is ever restocked: this
      // is exactly what the theme's own label already says for an in-stock
      // variant, and the theme's native disabled state is left untouched
      // either way, so a genuinely available fixed size still behaves
      // normally.
      setAddToCartLabel('Add to cart');
      return false;
    }

    // "Quantity" here is the bundle size, not a per-unit count. Adding 2 of a
    // line would charge the fixed component twice, so pin the stepper to 1.
    function lockQuantityStepper() {
      var form = getProductForm();

      // The quantity block is not always inside the form either, so fall back
      // to a document-wide lookup.
      var stepper = (form && form.querySelector('input[name="quantity"]'))
        || document.querySelector('input[name="quantity"]');
      if (!stepper) return;

      stepper.value = '1';
      stepper.min = '1';
      stepper.max = '1';
      stepper.readOnly = true;

      // Hide the whole quantity block, not just the stepper: the label lives
      // outside <quantity-input>, so hiding only the input left a stray
      // "Quantity" heading sitting above the artwork upload. Note this label
      // means cart quantity, which is always 1 here, and is easily confused
      // with the "Quantity:" bundle-size option.
      var wrapper = stepper.closest('.product-form__quantity')
        || stepper.closest('.product-form__input')
        || stepper.closest('quantity-input, .quantity');
      if (wrapper) wrapper.style.display = 'none';
    }

    function bindListeners() {
      var field = document.getElementById('custom-size-field');
      if (!field) return;

      // Bound on document, not on the form. Themes like Horizon render the
      // variant picker OUTSIDE the add-to-cart form, so a form-scoped change
      // listener never sees the tier change and the preview goes stale (it
      // would keep showing the previous tier's price while the cart charges the
      // new one). Capture phase so it fires even if a theme stops propagation.
      if (!document.documentElement.dataset.dtfChangeBound) {
        document.documentElement.dataset.dtfChangeBound = 'true';
        document.addEventListener('change', function () {
          if (syncVisibility()) validateAndPreview();
          syncMirroredProperties();
        }, true);

        // Order notes and the large-file link are typed, not selected.
        document.addEventListener('input', function (event) {
          var target = event.target;
          if (!target || (target.id !== 'order_notes' && target.id !== 'external_link' && target.id !== 'cutting_notes')) return;
          syncMirroredProperties();
        }, true);
      }

      var quoteForm = document.getElementById('custom-size-quote-form');
      if (quoteForm && !quoteForm.dataset.dtfBound) {
        quoteForm.dataset.dtfBound = 'true';
        quoteForm.addEventListener('submit', function () {
          // Re-read the theme's fields: the customer may have typed the order
          // notes after the size, which would not have re-run validation.
          var finishInput = document.querySelector('input[name="properties[Finish]"]:checked');
          var externalInput = document.getElementById('external_link');
          var notesInput = document.getElementById('order_notes');
          var assign = function (id, value) {
            var el = document.getElementById(id);
            if (el) el.value = value;
          };
          assign('quote_finish', finishInput ? finishInput.value : '');
          assign('quote_external', externalInput ? externalInput.value : '');
          assign('quote_body', notesInput ? notesInput.value : '');

          // Consumed on the NEXT page load, never on this one.
          try {
            sessionStorage.setItem(QUOTE_PENDING_KEY, '1');
            sessionStorage.removeItem(QUOTE_SEEN_KEY);
          } catch (e) {}
        });
      }

      [['custom_size_w', 'w'], ['custom_size_h', 'h']].forEach(function (pair) {
        var input = document.getElementById(pair[0]);
        if (!input) return;

        // Fix D: restore what the customer typed before the re-render. Done
        // before binding so the restore cannot itself fire the handler.
        if (!input.value && lastTypedSize[pair[1]]) input.value = lastTypedSize[pair[1]];

        if (input.dataset.previewBound) return;
        input.dataset.previewBound = 'true';
        input.addEventListener('input', function () {
          lastTypedSize[pair[1]] = input.value;
          validateAndPreview();
        });
        // A number input can also be changed by its spinner or by the browser's
        // autofill, neither of which always emits "input".
        input.addEventListener('change', function () {
          lastTypedSize[pair[1]] = input.value;
          validateAndPreview();
        });
      });
    }

    function init() {
      placeCustomSizeField();
      placePriceDisplay();
      placeShippingNotice();
      placeQuote();
      placeProperties();
      syncMirroredProperties();
      lockQuantityStepper();
      bindListeners();
      bindCarrierSubmit();
      setHiddenFieldsSubmitted(false);
      // Fix C: validate on load so Add-to-cart starts disabled.
      if (syncVisibility()) validateAndPreview();

      decideConfirmation();
      handleQuoteConfirmation();

      var rerenderTimer = null;
      var observer = new MutationObserver(function () {
        placeCustomSizeField();
        placePriceDisplay();
        placeShippingNotice();
        placeQuote();
        placeProperties();
        syncMirroredProperties();
        lockQuantityStepper();
        bindListeners();
        // A variant change re-renders the section, which can replace the picker
        // without emitting a change event we can see. Recompute after the DOM
        // settles so the preview can never lag the selected tier.
        clearTimeout(rerenderTimer);
        rerenderTimer = setTimeout(function () {
          if (syncVisibility()) validateAndPreview();
          handleQuoteConfirmation();
        }, 60);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();